import React from 'react';
import TicketConfirmationText from './TicketConfirmationText';
import TicketStateBase from '../TicketStateBase';
import { useSelector } from 'react-redux';
import succesSendRequestIcon from '../../../assets/selfService/succesSendRequest.svg';
import { useLocation } from 'react-router-dom';

const TicketConfirmationInnerForms = () => {
  const { ticketId } = useSelector((state) => state.ticketsReducer);
  const location = useLocation();

  return (
    <TicketStateBase
      mobile={location.state.mobile}
      texts={<TicketConfirmationText ticketId={ticketId} />}
      image={succesSendRequestIcon}
      returnText="Realizar otra solicitud"
      simpleText="Ir a ripley.com"
    />
  );
};

export default TicketConfirmationInnerForms;
